import React from 'react';
import PropTypes from 'prop-types';

const TitleMain = props => {
  const severity = props.categorizationSeverity ? props.categorizationSeverity : 'OUTOFRISK';
  const borderLeft = props.borderLeft ? `${severity} main_title_new new` : 'main_title_new new';
  return (
    <section className={`${borderLeft}`}>
      <h1>{props.title ? props.title : ''}</h1>
    </section>
  );
};

export default TitleMain;



// WEBPACK FOOTER //
// ./source/client/components/summary_fatigue/titleMain.jsx